var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button as LuiButton } from '@lendi-ui/button';
import { margin } from '@lendi-ui/spacing';
// @ts-ignore
export var Button = styled(LuiButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  width: 70%;\n  height: 48px;\n"], ["\n  ", ";\n  width: 70%;\n  height: 48px;\n"])), margin);
var templateObject_1;
//# sourceMappingURL=ButtonWithMargin.js.map